import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Container,
  TextField,
  Button,
  Tabs,
  Tab,
  Box,
  Switch,
  FormControlLabel,
  Grid,
  Card,
  CardContent,
  CardActions,
  IconButton,
  InputAdornment,
  LinearProgress,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  CircularProgress,
  Tooltip
} from "@material-ui/core";
import MemoryOutlinedIcon from "@material-ui/icons/MemoryOutlined";
import AddIcon from "@material-ui/icons/Add";
import SettingsIcon from "@material-ui/icons/Settings";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import StorageOutlinedIcon from "@material-ui/icons/StorageOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import NotificationsActiveOutlinedIcon from "@material-ui/icons/NotificationsActiveOutlined";
import SwapHorizOutlinedIcon from "@material-ui/icons/SwapHoriz";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import MicNoneOutlinedIcon from "@material-ui/icons/MicNoneOutlined";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EditorDeImagem from "../../components/EditorDeImagem";
import { getBackendUrl } from "../../config";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import BankEnginePanel from "../../components/BankEnginePanel";
import AbaAudio from "./AbaAudio";
import RecordVoiceOverOutlinedIcon from "@material-ui/icons/RecordVoiceOverOutlined";
import { poderDeAdmin } from "../../utils/perfil";
import { cartaoAstro, painelAstro } from "../../utils/estiloAstro";
import {
  bannerNavy,
  bannerTitulo,
  bannerSub,
  botaoPrimario
} from "../../utils/estiloNavy";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import TuneRoundedIcon from "@material-ui/icons/TuneRounded";

// Campos secretos (chaves de API, senhas) SEM type="password".
// O Chrome trata qualquer input type="password" como tela de login: quando a
// aba troca e esses campos somem, ele acha que foi um "envio de formulario" e
// abre o balao "Atualizar senha?". Com type="text" + mascara via CSS o valor
// continua escondido na tela e o gerenciador de senhas ignora o campo.
const campoSecreto = (visivel, extra = {}) => ({
  ...extra,
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-form-type": "other",
  style: { ...(extra.style || {}), WebkitTextSecurity: visivel ? "none" : "disc" }
});

// Modelos do Claude (precos oficiais da Anthropic, out/2026, em US$ por
// milhao de tokens: entrada / saida). "esforco" = aceita output_config.effort.
const FAMILIAS_CLAUDE = [
  {
    id: "sonnet", nome: "Sonnet", desc: "Equilíbrio entre velocidade e inteligência",
    versoes: [
      { id: "claude-sonnet-5-5", nome: "Sonnet 5.5", entrada: 2, saida: 10, esforco: true, padrao: "high", nota: "Mais nova" },
      { id: "claude-sonnet-5", nome: "Sonnet 5", entrada: 2, saida: 10, esforco: true, padrao: "high" },
      { id: "claude-sonnet-4-6", nome: "Sonnet 4.6", entrada: 3, saida: 15, esforco: true, padrao: "high" },
    ],
  },
  {
    id: "opus", nome: "Opus", desc: "Para conversas complexas, mais inteligente",
    versoes: [
      { id: "claude-opus-5-5", nome: "Opus 5.5", entrada: 4, saida: 20, esforco: true, padrao: "medium", nota: "Mais nova" },
      { id: "claude-opus-5", nome: "Opus 5", entrada: 5, saida: 25, esforco: true, padrao: "high" },
      { id: "claude-opus-4-8", nome: "Opus 4.8", entrada: 5, saida: 25, esforco: true, padrao: "high" },
      { id: "claude-opus-4-7", nome: "Opus 4.7", entrada: 5, saida: 25, esforco: true, padrao: "high" },
      { id: "claude-opus-4-6", nome: "Opus 4.6", entrada: 5, saida: 25, esforco: true, padrao: "high" },
    ],
  },
  {
    id: "haiku", nome: "Haiku", desc: "Mais rápido e mais barato",
    versoes: [
      { id: "claude-haiku-4-5-20251001", nome: "Haiku 4.5", entrada: 1, saida: 5, esforco: false, aviso: "Pode sair do ar a partir de 15/10/2026" },
    ],
  },
  {
    id: "fable", nome: "Fable", desc: "Para os desafios mais difíceis — o mais caro",
    versoes: [
      { id: "claude-fable-5-1", nome: "Fable 5.1", entrada: 10, saida: 50, esforco: true, padrao: "high" },
    ],
  },
];
// Modelos da OpenAI (precos oficiais, out/2026, US$ por milhao de tokens).
// Todos usam a Responses API (ver backend ClienteIA) e aceitam esforco.
const FAMILIAS_OPENAI = [
  {
    id: "gpt6", nome: "GPT-6", desc: "Geração mais nova da OpenAI",
    versoes: [
      { id: "gpt-6.1-sol", nome: "GPT-6.1 Sol", entrada: 2, saida: 10, esforco: true, padrao: "medium", nota: "Recomendado" },
      { id: "gpt-6-astra", nome: "GPT-6 Astra", entrada: 10, saida: 50, esforco: true, padrao: "medium", nota: "Mais inteligente" },
      { id: "gpt-6-sol", nome: "GPT-6 Sol", entrada: 2, saida: 10, esforco: true, padrao: "medium" },
      { id: "gpt-6-luna", nome: "GPT-6 Luna", entrada: 0.1, saida: 0.5, esforco: true, padrao: "medium", nota: "Mais barato" },
    ],
  },
  {
    id: "gpt56", nome: "GPT-5.6", desc: "Geração anterior, ainda disponível",
    versoes: [
      { id: "gpt-5.6-sol", nome: "GPT-5.6 Sol", entrada: 4, saida: 20, esforco: true, padrao: "medium" },
      { id: "gpt-5.6-terra", nome: "GPT-5.6 Terra", entrada: 2, saida: 12, esforco: true, padrao: "medium" },
      { id: "gpt-5.6-luna", nome: "GPT-5.6 Luna", entrada: 0.2, saida: 1.2, esforco: true, padrao: "medium" },
    ],
  },
  {
    id: "gpt5", nome: "GPT-5.5 e anteriores", desc: "Modelos mais antigos",
    versoes: [
      { id: "gpt-5.5", nome: "GPT-5.5", entrada: 5, saida: 30, esforco: true, padrao: "medium" },
      { id: "gpt-5.4", nome: "GPT-5.4", entrada: 2.5, saida: 15, esforco: true, padrao: "medium" },
      { id: "gpt-5.4-mini", nome: "GPT-5.4 mini", entrada: 0.75, saida: 4.5, esforco: true, padrao: "medium" },
      { id: "gpt-5-mini", nome: "GPT-5 mini", entrada: 0.25, saida: 2, esforco: true, padrao: "medium" },
      { id: "gpt-5-nano", nome: "GPT-5 nano", entrada: 0.05, saida: 0.4, esforco: true, padrao: "medium" },
    ],
  },
];
const PROVEDORES = [
  { id: "claude", nome: "Claude", desc: "Anthropic", familias: FAMILIAS_CLAUDE },
  { id: "openai", nome: "ChatGPT", desc: "OpenAI", familias: FAMILIAS_OPENAI },
];
const ehOpenAI = (model) => /^(gpt-|o\d)/i.test(String(model || "").trim());
const ESFORCOS = [
  { id: "", nome: "Padrão do modelo" },
  { id: "low", nome: "Baixo", desc: "Responde mais rápido e gasta menos" },
  { id: "medium", nome: "Médio", desc: "Equilíbrio" },
  { id: "high", nome: "Alto", desc: "Pensa mais antes de responder" },
];
const NOME_ESFORCO = { low: "Baixo", medium: "Médio", high: "Alto" };
const acharVersao = (id) => {
  for (const f of [...FAMILIAS_CLAUDE, ...FAMILIAS_OPENAI]) {
    const v = f.versoes.find((x) => x.id === id);
    if (v) return { familia: f, versao: v };
  }
  return null;
};
const usd = (n) => `US$ ${String(n).replace(".", ",")}`;

// "1:30" <-> 90 (segundos). Aceita também só números (= minutos).
const textoParaSegundos = texto => {
  const t = String(texto ?? "").trim();
  if (!t) return 90;
  let total;
  if (t.includes(":")) {
    const [m, sg] = t.split(":");
    total = (parseInt(m, 10) || 0) * 60 + (parseInt(sg, 10) || 0);
  } else {
    total = (parseInt(t, 10) || 0) * 60;
  }
  return Math.max(total || 90, 30);
};
const segundosParaTexto = segundos => {
  const n = Math.max(parseInt(segundos, 10) || 90, 30);
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;
};

const useStyles = makeStyles(theme => ({
  // A pagina inteira rola (banner junto), em vez de so o conteudo da aba.
  root: {
    display: "block",
    padding: theme.spacing(1.5, 2, 3),
    height: "100%",
    overflowY: "auto",
    backgroundColor: "transparent",
    ...theme.scrollbarStyles,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  // Sem a "caixa" em volta: o banner navy segura as abas e as secoes
  // ficam soltas no fundo pontilhado, como no resto do sistema.
  paper: {
    display: "flex",
    flexDirection: "column",
    overflow: "visible",
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
  },
  banner: {
    ...bannerNavy(theme),
    padding: "20px 24px 16px",
    flexShrink: 0,
  },
  bannerTopo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  bannerTitulo,
  bannerSub,
  bannerIcone: {
    width: 40, height: 40, borderRadius: 12,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    background: "linear-gradient(135deg,#22c55e,#15803d)",
    boxShadow: "0 6px 18px rgba(34,197,94,.35)",
  },
  bannerPill: {
    display: "inline-flex", alignItems: "center", gap: 7,
    padding: "6px 12px", borderRadius: 999, fontSize: "0.78rem", fontWeight: 800,
    border: "1px solid rgba(255,255,255,0.16)", backdropFilter: "blur(6px)",
  },
  // abas em "pilulas" de vidro dentro do banner
  tabs: {
    marginTop: 16,
    minHeight: 0,
    "& .MuiTabs-flexContainer": {
      display: "inline-flex",
      gap: 4,
      padding: 4,
      borderRadius: 14,
      backgroundColor: "rgba(255,255,255,0.07)",
      border: "1px solid rgba(255,255,255,0.12)",
    },
    "& .MuiTab-root": {
      minHeight: 38,
      minWidth: 0,
      padding: "6px 18px",
      textTransform: "none",
      fontSize: "0.88rem",
      color: "rgba(226,232,240,0.85)",
      borderRadius: 10,
      fontWeight: 700,
      opacity: 1,
      transition: "background-color .2s ease, color .2s ease",
      "&:hover": { color: "#ffffff", backgroundColor: "rgba(255,255,255,0.08)" },
      "& .MuiTab-wrapper": { flexDirection: "row", gap: 8 },
      "& .MuiTab-wrapper > *:first-child": { marginBottom: 0, fontSize: 18 },
    },
    "& .MuiTab-root.Mui-selected": theme.palette.type === "dark"
      ? {
          // no escuro: verde translúcido, igual ao item ativo do menu lateral
          color: "#86efac",
          background: "linear-gradient(135deg, rgba(34,197,94,.24), rgba(34,197,94,.08))",
          boxShadow: "inset 0 0 0 1px rgba(74,222,128,.45), 0 6px 18px rgba(34,197,94,.18)",
          "& .MuiSvgIcon-root": { color: "#4ade80 !important" },
        }
      : {
          color: "#1E9855",
          backgroundColor: "#ffffff",
          boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
          "& .MuiSvgIcon-root": { color: "#1E9855 !important" },
        },
    "& .MuiTabs-indicator": { display: "none" },
  },
  tabPanel: {
    padding: theme.spacing(2, 0.25, 1),
  },
  listCardContainer: {
    backgroundColor: "transparent",
    padding: "0",
  },
  listCard: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    ...cartaoAstro(theme),
    padding: "24px 32px",
    marginBottom: "16px",
    width: "100%",
  },
  listCardLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "32px",
  },
  listCardDragHandle: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    color: theme.palette.text.secondary,
    marginTop: "4px",
    cursor: "grab",
  },
  listCardOrder: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "14px",
  },
  listCardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  listCardTitle: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: "18px",
    letterSpacing: "0.5px",
  },
  listCardBankList: {
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    padding: "8px 12px",
    minWidth: "200px",
    backgroundColor: theme.palette.background.default,
  },
  listCardBankItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    color: theme.palette.text.secondary,
    fontSize: "13px",
    padding: "6px 0",
    "& span": {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      width: "16px",
    }
  },
  listCardSubtext: {
    color: theme.palette.text.hint || "#999",
    fontSize: "12px",
    marginTop: "4px",
  },
  listCardRight: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
    height: "100%",
    marginTop: "24px", 
  },
  listCardButton: {
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    textTransform: "none",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
      borderColor: theme.palette.text.secondary
    }
  },
  listCardStatus: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    fontWeight: 500,
  },
  switchBase: {
    "&$switchChecked": {
      color: "#4caf50",
    },
    "&$switchChecked + $switchTrack": {
      backgroundColor: "#4caf50",
    },
  },
  switchChecked: {},
  switchTrack: {},
  optionBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: "4px solid #22c55e",
    borderRadius: "12px",
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    transition: "box-shadow .2s ease, transform .2s ease",
    "&:hover": {
      transform: "translateX(3px)",
      boxShadow: theme.palette.type === "dark"
        ? "0 6px 16px rgba(0,0,0,0.4)"
        : "0 6px 16px rgba(16,40,28,0.08)",
    }
  },
  optionBoxDashed: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: "10px",
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  iaPanel: {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    animation: "iaSubir .4s ease backwards",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: "linear-gradient(90deg, #16a34a, #4ade80)",
    },
  },

  // ===== Configuracoes Globais =====
  cfgSecao: {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    marginBottom: 20,
    borderRadius: 20,
    animation: "iaSubir .4s ease backwards",
    boxShadow: theme.palette.type === "dark" ? "0 10px 28px rgba(0,0,0,.35)" : "0 8px 26px rgba(15,23,42,.06)",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0, left: 0, right: 0, height: 3,
      background: "linear-gradient(90deg, #16a34a, #4ade80)",
    },
  },
  cfgSecaoHead: {
    display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
    padding: "18px 24px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark"
      ? "linear-gradient(90deg, rgba(30,152,85,.10), transparent 60%)"
      : "linear-gradient(90deg, rgba(30,152,85,.06), transparent 60%)",
  },
  cfgIcone: {
    width: 42, height: 42, borderRadius: 12, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#ffffff",
    background: "linear-gradient(135deg, #34d399, #1E9855)",
    boxShadow: "0 6px 16px rgba(30,152,85,.3)",
    "& svg": { color: "#fff" },
  },
  cfgTitulo: { fontWeight: 800, fontSize: "1.02rem", color: theme.palette.text.primary, lineHeight: 1.25 },
  cfgSub: { fontSize: "0.8rem", color: theme.palette.text.secondary, marginTop: 2 },
  cfgCorpo: { padding: "20px 24px" },
  cfgGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.6fr) minmax(0, 1fr)",
    gap: 20,
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  cfgColuna: { display: "flex", flexDirection: "column", gap: 20 },
  cfgLinha2: {
    display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  cfgBloco: {
    display: "flex", flexDirection: "column", gap: 14,
    padding: 18, borderRadius: 16,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.07)" : "#e8eef4"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#f8fafc",
  },
  cfgBlocoTitulo: {
    display: "flex", alignItems: "center", gap: 8,
    fontSize: "0.72rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary,
    "& svg": { fontSize: 17, color: "#1E9855" },
  },
  cfgRodape: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap",
    padding: "14px 24px",
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#f8faf9",
  },
  cfgRodapeTexto: { fontSize: "0.76rem", color: theme.palette.text.secondary },
  cfgBotao: {
    ...botaoPrimario,
  },
  cfgPill: {
    display: "inline-flex", alignItems: "center", gap: 6,
    fontSize: "0.72rem", fontWeight: 800, padding: "4px 10px", borderRadius: 20, whiteSpace: "nowrap",
  },
  cfgPillOn: { color: "#15803d", backgroundColor: "rgba(34,197,94,.15)" },
  cfgPillOff: { color: "#64748b", backgroundColor: "rgba(148,163,184,.18)" },
  cfgPillWarn: { color: "#b45309", backgroundColor: "rgba(245,158,11,.15)" },
  cfgPonto: { width: 7, height: 7, borderRadius: "50%", backgroundColor: "currentColor" },
  cfgSwitchLinha: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
    padding: "10px 14px", borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "0.88rem", fontWeight: 600, color: theme.palette.text.primary,
  },
  cfgSeg: {
    display: "inline-flex", padding: 4, gap: 4, borderRadius: 12, marginLeft: "auto",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.05)" : "#eef2f0",
  },
  cfgSegBtn: {
    border: "none", background: "none", cursor: "pointer", fontFamily: "inherit",
    fontSize: "0.84rem", fontWeight: 700, padding: "7px 16px", borderRadius: 9,
    color: theme.palette.text.secondary,
    "&:hover": { color: theme.palette.text.primary },
    "&:focus": { outline: "none" },
  },
  cfgSegAtivo: {
    color: "#1E9855", "&:hover": { color: "#1E9855" },
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 1px 4px rgba(0,0,0,.08)",
  },
  cfgPrompt: {
    "& textarea": {
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      fontSize: "0.82rem", lineHeight: 1.55, resize: "vertical",
    },
    "& .MuiOutlinedInput-root": {
      alignItems: "flex-start", borderRadius: 12,
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#fbfcfb",
    },
  },
  cfgResumo: {
    display: "flex", alignItems: "flex-start", gap: 10,
    padding: "11px 14px", borderRadius: 12, marginBottom: 16,
    fontSize: "0.82rem", lineHeight: 1.45, color: theme.palette.text.primary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.10)" : "rgba(30,152,85,.06)",
    border: "1px solid rgba(30,152,85,.20)",
    "& b": { color: "#15803d" },
  },
  cfgSegPonto: { width: 7, height: 7, borderRadius: "50%", display: "inline-block", marginRight: 7, verticalAlign: "middle" },
  cfgAtivoLinha: {
    display: "flex", alignItems: "center", gap: 6,
    fontSize: "0.8rem", fontWeight: 700, color: theme.palette.text.primary, whiteSpace: "nowrap",
  },
  iaGrid4: {
    display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 16,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  iaSpan2: {
    gridColumn: "span 2",
    [theme.breakpoints.down("xs")]: { gridColumn: "span 1" },
  },
  iaGrid3: {
    display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 16,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  iaGrid2: {
    display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 20, alignItems: "start",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  iaOpcao: {
    display: "flex", flexDirection: "column", gap: 10,
    padding: "14px 16px", borderRadius: 14,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e8eef4"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
    transition: "border-color .15s, box-shadow .15s",
    "&:hover": { borderColor: "rgba(30,152,85,.35)", boxShadow: "0 6px 16px -10px rgba(30,152,85,.6)" },
  },
  iaOpcaoTopo: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 },
  iaOpcaoTitulo: { fontSize: "0.88rem", fontWeight: 800, color: theme.palette.text.primary },
  iaOpcaoTexto: { fontSize: "0.76rem", color: theme.palette.text.secondary, marginTop: 2, lineHeight: 1.45 },
  iaRotulo: {
    fontSize: "0.72rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary, margin: "20px 0 10px",
  },
  zap: { borderRadius: 12, overflow: "hidden", border: "1px solid rgba(18,140,126,.35)", backgroundColor: "#efeae2" },
  zapTopo: { backgroundColor: "#128c7e", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, color: "#fff" },
  zapAvatar: {
    width: 30, height: 30, borderRadius: "50%", backgroundColor: "rgba(255,255,255,.22)",
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15,
  },
  zapNome: { fontWeight: 700, fontSize: "0.86rem", lineHeight: 1.1 },
  zapSub: { fontSize: "0.72rem", opacity: 0.85 },
  zapCorpo: { padding: 14, minHeight: 90 },
  zapBalao: {
    backgroundColor: "#fff", borderRadius: "0 8px 8px 8px", padding: "9px 12px", display: "inline-block",
    maxWidth: "92%", color: "#111", fontSize: "0.86rem", lineHeight: 1.45, boxShadow: "0 1px 1px rgba(0,0,0,.12)",
    whiteSpace: "pre-wrap", wordBreak: "break-word",
  },
  zapFoto: {
    display: "block", width: "100%", maxWidth: 260, borderRadius: 6, marginBottom: 6, objectFit: "cover",
  },
  fotoArea: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 16 },
  fotoMini: {
    position: "relative", width: 64, height: 64, borderRadius: 12, overflow: "hidden", cursor: "pointer",
    border: `1px solid ${theme.palette.divider}`, flexShrink: 0,
    "& img": { width: "100%", height: "100%", objectFit: "cover", display: "block" },
    "&:hover $fotoLapis": { opacity: 1 },
  },
  fotoLapis: {
    position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
    backgroundColor: "rgba(0,0,0,.45)", color: "#fff", opacity: 0, transition: "opacity .15s",
  },
  fotoVazia: {
    width: 64, height: 64, borderRadius: 12, flexShrink: 0, cursor: "pointer",
    border: `1.5px dashed ${theme.palette.divider}`, color: theme.palette.text.secondary,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  fotoDica: { fontSize: "0.74rem", color: theme.palette.text.secondary, lineHeight: 1.45, flexBasis: "100%" },
  zapBalaoMeu: { backgroundColor: "#d9fdd3", borderRadius: "8px 0 8px 8px", float: "right" },
  cfgInfoPrompt: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap",
    fontSize: "0.78rem", color: theme.palette.text.secondary, marginBottom: 12,
  },
  cfgLink: { color: "#1E9855", fontWeight: 700 },
  // seletor de modelo: familia -> versao -> esforco
  familias: {
    display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 8,
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
  },
  familiaBtn: {
    textAlign: "left", cursor: "pointer", fontFamily: "inherit",
    padding: "10px 12px", borderRadius: 12, position: "relative",
    border: `1.5px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff",
    transition: "border-color .15s, background-color .15s",
    "&:hover": { borderColor: "rgba(30,152,85,.5)", transform: "translateY(-1px)" },
    "&:focus": { outline: "none" },
  },
  familiaAtiva: {
    borderColor: "#1E9855",
    backgroundColor: theme.palette.type === "dark" ? "rgba(30,152,85,.14)" : "#f0fbf4",
    boxShadow: "0 0 0 3px rgba(30,152,85,.12)",
    "&::after": {
      content: '"✓"', position: "absolute", top: 8, right: 10,
      width: 18, height: 18, borderRadius: "50%", fontSize: 11, fontWeight: 900,
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#fff", background: "linear-gradient(135deg,#34d399,#1E9855)",
    },
  },
  // Escolha da IA: a que nao esta em uso aparece apagada e "Desativada".
  provedores: { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 8 },
  provedorInativo: {
    opacity: 0.55,
    filter: "grayscale(1)",
    "&:hover": { opacity: 0.85, filter: "none" },
  },
  provedorStatus: {
    display: "inline-block", marginTop: 6, padding: "1px 8px", borderRadius: 20,
    fontSize: "0.65rem", fontWeight: 800, letterSpacing: ".02em",
  },
  provedorStatusAtivo: { color: "#15803d", backgroundColor: "rgba(34,197,94,.18)" },
  provedorStatusInativo: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#eef2f6",
  },
  familiaNome: { fontSize: "0.88rem", fontWeight: 800, color: theme.palette.text.primary },
  familiaDesc: { fontSize: "0.7rem", color: theme.palette.text.secondary, marginTop: 2, lineHeight: 1.3 },
  opcaoLinha: { display: "flex", alignItems: "center", gap: 10, width: "100%" },
  opcaoNome: { fontSize: "0.88rem", fontWeight: 700 },
  opcaoPreco: { marginLeft: "auto", fontSize: "0.72rem", fontWeight: 700, color: theme.palette.text.secondary, whiteSpace: "nowrap" },
  opcaoNota: { fontSize: "0.65rem", fontWeight: 800, padding: "1px 7px", borderRadius: 20, color: "#15803d", backgroundColor: "rgba(34,197,94,.15)" },
  precoCaixa: {
    marginTop: 4,
    display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10,
  },
  precoTile: {
    padding: "12px 14px 12px 17px", borderRadius: 14, position: "relative", overflow: "hidden",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e8eef4"}`,
    "&::before": {
      content: '""', position: "absolute", left: 0, top: 0, bottom: 0, width: 3,
      background: "linear-gradient(180deg,#34d399,#1E9855)",
    },
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
  },
  precoRotulo: {
    fontSize: "0.66rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  precoValor: { fontSize: "1.15rem", fontWeight: 800, color: theme.palette.text.primary, marginTop: 4, lineHeight: 1.1 },
  precoSub: { fontSize: "0.7rem", color: theme.palette.text.secondary, marginTop: 2 },

  modernSelect: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      fontSize: "0.9rem",
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#fafafa",
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#1E9855",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1E9855",
        borderWidth: 1.5,
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.875rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#1E9855",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.secondary,
    },
  },
  modernSelectMenu: {
    borderRadius: "10px !important",
    marginTop: 4,
    maxHeight: 220,
    "& .MuiList-padding": {
      padding: "4px 0",
    },
    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.divider,
      borderRadius: 4,
    },
  },
  modernMenuItem: {
    fontSize: "0.875rem",
    borderRadius: 6,
    margin: "1px 4px",
    padding: "8px 12px",
    "&.Mui-selected": {
      backgroundColor: "rgba(30, 152, 85, 0.10) !important",
      color: "#1E9855",
      fontWeight: 600,
    },
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
    },
  },
  sectorChipDivider: {
    margin: "4px 8px",
    height: 1,
    backgroundColor: theme.palette.divider,
  },
  notifActivateBtn: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.82rem",
    padding: "5px 16px",
  },
  notifActiveChip: {
    backgroundColor: "rgba(30,152,85,0.12)",
    color: "#1E9855",
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: 8,
    height: 28,
  },
  notifBlockedChip: {
    backgroundColor: "rgba(229,57,53,0.12)",
    color: "#e53935",
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: 8,
    height: 28,
  },
}));

function TabPanel(props) {
  const { children, value, index, className, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      className={className}
      {...other}
      style={{ display: value === index ? "block" : "none" }}
    >
      {value === index && children}
    </div>
  );
}

// Blocos da aba IA. Ficam FORA do componente: definidos dentro dele, o
// React remontaria os campos a cada tecla e o cursor sairia do campo.
const SecaoIa = ({ classes, salvando, onSalvar, id, icone, titulo, sub, acao, children }) => (
                <div className={classes.cfgSecao}>
                  <div className={classes.cfgSecaoHead}>
                    <div className={classes.cfgIcone}>{icone}</div>
                    <div style={{ flex: 1, minWidth: 220 }}>
                      <div className={classes.cfgTitulo}>{titulo}</div>
                      <div className={classes.cfgSub}>{sub}</div>
                    </div>
                    {acao}
                  </div>
                  <div className={classes.cfgCorpo}>{children}</div>
                  <div className={classes.cfgRodape}>
                    <span className={classes.cfgRodapeTexto}>As mudanças valem a partir do próximo atendimento.</span>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.cfgBotao}
                      startIcon={<SaveOutlinedIcon />}
                      disabled={salvando === id}
                      onClick={() => onSalvar(id)}
                    >
                      {salvando === id ? "Salvando…" : "Salvar"}
                    </Button>
                  </div>
                </div>
              );
const ZapPrevia = ({ classes, emoji, nome, sub, children }) => (
                <div className={classes.zap}>
                  <div className={classes.zapTopo}>
                    <div className={classes.zapAvatar}>{emoji}</div>
                    <div>
                      <div className={classes.zapNome}>{nome}</div>
                      <div className={classes.zapSub}>{sub}</div>
                    </div>
                  </div>
                  <div className={classes.zapCorpo}>{children}</div>
                </div>
              );

const AIConfig = () => {
  const classes = useStyles();

  const [tab, setTab] = useState(0);

  const [generalConfig, setGeneralConfig] = useState({
    enabled: false,
    apiKey: "",
    model: "claude-sonnet-5",
    systemPrompt: "",
    fgtsSystemPrompt: "",
  });
  // Qual prompt esta aberto no editor: CLT (padrao) ou FGTS.
  const [promptAba, setPromptAba] = useState("clt");
  const [faqAba, setFaqAba] = useState("clt");
  // So deixa salvar depois de carregar: salvar com a tela vazia apagaria tudo.
  const [carregado, setCarregado] = useState(false);
  const [salvando, setSalvando] = useState("");

  

  const [lemittiConfig, setLemittiConfig] = useState({ lemittiUrl: "" });

  const [coonsigleToken, setCoonsigleToken] = useState("");

  
  const [lemittiContas, setLemittiContas] = useState([{ email: "", senha: "" }]);
  const [senhasVisiveis, setSenhasVisiveis] = useState({});

  
  
  const [segredosVisiveis, setSegredosVisiveis] = useState({});

  const olhoMagico = chave => ({
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          size="small"
          edge="end"
          aria-label={segredosVisiveis[chave] ? "Esconder" : "Mostrar"}
          onClick={() =>
            setSegredosVisiveis({
              ...segredosVisiveis,
              [chave]: !segredosVisiveis[chave]
            })
          }
        >
          {segredosVisiveis[chave] ? (
            <Visibility fontSize="small" />
          ) : (
            <VisibilityOff fontSize="small" />
          )}
        </IconButton>
      </InputAdornment>
    )
  });

  // Foto da assistente: salva na hora pelo proprio botao (nao depende do "Salvar").
  const [fotoAssistente, setFotoAssistente] = useState("");
  const [fotoParaEditar, setFotoParaEditar] = useState(null);
  const [enviandoFoto, setEnviandoFoto] = useState(false);
  const [abrindoFoto, setAbrindoFoto] = useState(false);

  const [iaConfig, setIaConfig] = useState({
    companyName: "Consig Tech Promotora",
    website: "www.consigtechpromotora.com",
    cnpj: "33559120000182",
    yearsInBusiness: "9",
    state: "SP - São Paulo",
    city: "São Paulo",
    assistantName: "Thainá Lima",
    dailyNotifications: true,
    dailyNotificationTime: "18:00",
    generalNotifications: true,
    proposalNotifications: true,
    saleNotifications: true,
    adminNotificationNumber: "",
    overflowNumber: "",
    leadQualificationFollowUp: false,
    leadQualificationFollowUpMinutes: 30,
    leadQualificationFollowUpMax: 1,
    faqContent: "",
    faqFgtsContent: "",
    transferQueueCltId: "",
    transferQueueFgtsId: "",
    autoTransferProduct: "",
    autoTransferUserId: "",
    autoTransferUserIds: [],
    overflowTimeoutMinutes: 10,
    flowTimeoutMinutes: 10,
    iaTimeoutMinutes: 15,
    retomadaPausaSegundos: "1:30",
    leadQualificationMessage: "Olá! Me chamo Astro, e darei continuidade em seu atendimento 😊",
    paymentSuccessMessage: "*Tudo certo!*\n\nSua transferência já foi realizada e o valor deve estar disponível em sua conta.",
  });

  const [pushNotifStatus, setPushNotifStatus] = useState("default"); 

  
  const [atendentes, setAtendentes] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/users/");
        setAtendentes((data.users || []).filter(u => u.profile === "user"));
      } catch (err) {
        
      }
    })();
    fetchConfigs();
    
    if ("Notification" in window) {
      setPushNotifStatus(Notification.permission);
    }
    
  }, []);

  const handleActivatePushNotifications = async () => {
    if (!("Notification" in window)) {
      toast.error("Seu navegador não suporta notificações push.");
      return;
    }
    try {
      const permission = await Notification.requestPermission();
      setPushNotifStatus(permission);
      if (permission === "granted") {
        toast.success("Notificações ativadas neste dispositivo!");
        new Notification("Notificações ativadas!", {
          body: "Você receberá alertas de venda neste navegador.",
          icon: "/favicon.ico",
        });
      } else if (permission === "denied") {
        toast.error("Notificações bloqueadas. Altere nas configurações do navegador.");
      }
    } catch (err) {
      toastError(err);
    }
  };

  
  useEffect(() => {
    const id = setInterval(async () => {
      try {
        const { data } = await api.get("/ai/config");
        if (data) {
          setGeneralConfig(prev => ({
            ...prev,
            totalInputTokens: data.totalInputTokens,
            totalOutputTokens: data.totalOutputTokens,
          }));
        }
      } catch (e) {
        
      }
    }, 15000);
    return () => clearInterval(id);
  }, []);

  const fetchConfigs = async () => {
    try {
      const { data: generalData } = await api.get("/ai/config");
      if (generalData) {
        setGeneralConfig(generalData);
        setCarregado(true);
        setLemittiConfig({ lemittiUrl: generalData.lemittiUrl || "" });

        
        setCoonsigleToken(generalData.coonsigleToken || "");
        setFotoAssistente(generalData.assistantPhotoUrl || "");

        let contas = [];
        try {
          contas = generalData.lemittiContas ? JSON.parse(generalData.lemittiContas) : [];
        } catch (e) {
          contas = [];
        }
        if (!contas.length && generalData.lemittiEmail) {
          contas = [{ email: generalData.lemittiEmail, senha: generalData.lemittiPassword || "" }];
        }
        setLemittiContas(contas.length ? contas : [{ email: "", senha: "" }]);
        setIaConfig({
          companyName: generalData.companyName || "Consig Tech Promotora",
          website: generalData.website || "www.consigtechpromotora.com",
          cnpj: generalData.cnpj || "33559120000182",
          yearsInBusiness: generalData.yearsInBusiness || "9",
          state: generalData.state || "SP - São Paulo",
          city: generalData.city || "São Paulo",
          assistantName: generalData.assistantName || "Thainá Lima",
          dailyNotifications: generalData.dailyNotifications !== false,
          dailyNotificationTime: generalData.dailyNotificationTime || "18:00",
          generalNotifications: generalData.generalNotifications !== false,
          proposalNotifications: generalData.proposalNotifications !== false,
          saleNotifications: generalData.saleNotifications !== false,
          adminNotificationNumber: semDDI(generalData.adminNotificationNumber),
          overflowNumber: semDDI(generalData.overflowNumber),
          leadQualificationFollowUp: generalData.leadQualificationFollowUp ?? false,
          leadQualificationFollowUpMinutes: generalData.leadQualificationFollowUpMinutes ?? 30,
          leadQualificationFollowUpMax: generalData.leadQualificationFollowUpMax ?? 1,
          faqContent: generalData.faqContent || "",
          faqFgtsContent: generalData.faqFgtsContent || "",
          transferQueueCltId: generalData.transferQueueCltId || "",
          transferQueueFgtsId: generalData.transferQueueFgtsId || "",
          autoTransferProduct: generalData.autoTransferProduct || "",
          autoTransferUserId: generalData.autoTransferUserId || "",
          autoTransferUserIds: Array.isArray(generalData.autoTransferUserIds)
            ? generalData.autoTransferUserIds.map(String)
            : [],
          overflowTimeoutMinutes: generalData.overflowTimeoutMinutes ?? 10,
          flowTimeoutMinutes: generalData.flowTimeoutMinutes ?? 10,
          iaTimeoutMinutes: generalData.iaTimeoutMinutes ?? 15,
          retomadaPausaSegundos: segundosParaTexto(generalData.retomadaPausaSegundos ?? 90),
          leadQualificationMessage: generalData.leadQualificationMessage || "Olá! Me chamo Astro, e darei continuidade em seu atendimento 😊",
          audioToHumanEnabled: generalData.audioToHumanEnabled !== false,
          audioToHumanMessage: generalData.audioToHumanMessage || "",
          paymentSuccessMessage: generalData.paymentSuccessMessage || "*Tudo certo!*\n\nSua transferência já foi realizada e o valor deve estar disponível em sua conta.",
        });
      }

    } catch (err) {
      toastError(err);
    }
  };





  const handleGeneralSave = async () => handleSalvarConexoes();

  // Liga/desliga, modelo, chaves de API e token do Coonsigle.
  const handleSalvarConexoes = async () => {
    if (!carregado) return;
    setSalvando("conexoes");
    try {
      await api.put("/ai/config", {
        enabled: generalConfig.enabled,
        apiKey: generalConfig.apiKey,
        openaiApiKey: generalConfig.openaiApiKey,
        model: generalConfig.model,
        modelEffort: generalConfig.modelEffort || "",
        coonsigleToken: (coonsigleToken || "").trim()
      });
      toast.success("Conexões e modelo salvos!");
      await fetchConfigs();
    } catch (err) {
      toastError(err);
    } finally {
      setSalvando("");
    }
  };

  // Os dois prompts de conversa (CLT e FGTS).
  const handleSalvarPrompt = async () => {
    if (!carregado) return;
    const cltLigado = generalConfig.promptCltAtivo !== false;
    const fgtsLigado = generalConfig.promptFgtsAtivo !== false;
    if (!cltLigado && !fgtsLigado &&
        !window.confirm("CLT e FGTS desativados: a IA não vai atender ninguém. O fluxo continua e o cliente vai direto para um atendente. Confirmar?")) {
      return;
    }
    if (fgtsLigado && !String(generalConfig.fgtsSystemPrompt || "").trim()) {
      toast.error("O FGTS está ativo mas o prompt dele está vazio. Escreva o prompt ou desative o FGTS.");
      setPromptAba("fgts");
      return;
    }
    setSalvando("prompt");
    try {
      await api.put("/ai/config", {
        systemPrompt: generalConfig.systemPrompt || "",
        fgtsSystemPrompt: generalConfig.fgtsSystemPrompt || "",
        promptCltAtivo: cltLigado,
        promptFgtsAtivo: fgtsLigado
      });
      toast.success("Prompts salvos!");
      await fetchConfigs();
    } catch (err) {
      toastError(err);
    } finally {
      setSalvando("");
    }
  };

  const urlFotoAssistente = fotoAssistente ? `${getBackendUrl()}public/${fotoAssistente}` : "";

  const escolherFoto = (e) => {
    const arquivo = e.target.files?.[0];
    e.target.value = "";
    if (!arquivo) return;
    if (!/^image\/(jpe?g|png|webp)$/i.test(arquivo.type)) {
      toast.error("Use uma imagem JPG, PNG ou WEBP.");
      return;
    }
    if (arquivo.size > 15 * 1024 * 1024) {
      toast.error("A imagem precisa ter no máximo 15 MB.");
      return;
    }
    setFotoParaEditar(arquivo);
  };

  const editarFotoAtual = async () => {
    if (!fotoAssistente || abrindoFoto) return;
    setAbrindoFoto(true);
    try {
      const { data, headers } = await api.get(`/public/${fotoAssistente}`, { responseType: "blob" });
      setFotoParaEditar(new File([data], fotoAssistente, { type: headers["content-type"] || "image/jpeg" }));
    } catch (err) {
      toastError(err);
    } finally {
      setAbrindoFoto(false);
    }
  };

  const enviarFoto = async (arquivoFinal) => {
    setFotoParaEditar(null);
    setEnviandoFoto(true);
    try {
      const corpo = new FormData();
      corpo.append("assistantPhoto", arquivoFinal);
      const { data } = await api.post("/ai/config/assistant-photo", corpo, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFotoAssistente(data.assistantPhotoUrl || "");
      toast.success("Foto da assistente atualizada!");
    } catch (err) {
      toastError(err);
    } finally {
      setEnviandoFoto(false);
    }
  };

  const removerFoto = async () => {
    setEnviandoFoto(true);
    try {
      await api.delete("/ai/config/assistant-photo");
      setFotoAssistente("");
      toast.success("Foto removida. A abertura volta a sair só com texto.");
    } catch (err) {
      toastError(err);
    } finally {
      setEnviandoFoto(false);
    }
  };

  // Cada bloco da aba IA tem o proprio "Salvar" (salva o que esta na tela).
  const salvarBlocoIa = async (bloco) => {
    setSalvando(bloco);
    try {
      await handleIaSave();
    } finally {
      setSalvando("");
    }
  };

  const handleIaSave = async () => {
    try {
      await api.put("/ai/config", {
        ...iaConfig,
        retomadaPausaSegundos: textoParaSegundos(iaConfig.retomadaPausaSegundos),
        
        adminNotificationNumber: comDDI(iaConfig.adminNotificationNumber),
        overflowNumber: comDDI(iaConfig.overflowNumber)
      });
      toast.success("Configurações da IA salvas com sucesso!");
      await fetchConfigs();
    } catch (err) {
      toastError(err);
    }
  };

  
  
  const semDDI = (valor) => {
    const v = String(valor || "").replace(/\D/g, "");
    return v.startsWith("55") && v.length > 11 ? v.slice(2) : v;
  };

  const comDDI = (valor) => {
    const v = String(valor || "").replace(/\D/g, "");
    if (!v) return "";
    return v.startsWith("55") && v.length > 11 ? v : `55${v}`;
  };

  const aoDigitarTelefone = (campo) => (e) => {
    
    const v = e.target.value.replace(/\D/g, "").slice(0, 11);
    setIaConfig({ ...iaConfig, [campo]: v });
  };

  const getMaskedAdminNumber = (value) => {
    const v = semDDI(value);
    if (!v) return "";
    if (v.length <= 2) return `(${v}`;
    if (v.length <= 6) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
    if (v.length <= 10) return `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`;
    return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7, 11)}`;
  };

  const aoDigitarHorario = (e) => {
    let raw = e.target.value.replace(/\D/g, "").slice(0, 4);
    if (!raw) {
      setIaConfig({ ...iaConfig, dailyNotificationTime: "" });
      return;
    }
    if (raw.length <= 2) {
      setIaConfig({ ...iaConfig, dailyNotificationTime: raw });
      return;
    }
    let hh = raw.slice(0, 2);
    let mm = raw.slice(2);
    if (parseInt(hh, 10) > 23) hh = "23";
    if (mm.length === 2 && parseInt(mm, 10) > 59) mm = "59";
    setIaConfig({ ...iaConfig, dailyNotificationTime: `${hh}:${mm}` });
  };

  return (
    <div className={classes.root}>
      <EditorDeImagem
        open={!!fotoParaEditar}
        arquivo={fotoParaEditar}
        onCancel={() => setFotoParaEditar(null)}
        onConfirmar={enviarFoto}
      />
      <Container maxWidth="xl" className={classes.mainContainer}>
        <Paper className={classes.paper}>
          <div className={classes.banner}>
            <div className={classes.bannerTopo}>
              <div>
                <div className={classes.bannerTitulo}>
                  <span className={classes.bannerIcone}>
                    <MemoryOutlinedIcon />
                  </span>
                  Assistente de IA
                </div>
                <div className={classes.bannerSub}>
                  Modelo, comportamento da Catarina e bancos que ela consulta.
                </div>
              </div>
              <span
                className={classes.bannerPill}
                style={
                  generalConfig.enabled
                    ? { color: "#4ade80", background: "rgba(74,222,128,0.14)" }
                    : { color: "#cbd5e1", background: "rgba(148,163,184,0.16)" }
                }
              >
                <span
                  style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: generalConfig.enabled ? "#4ade80" : "#94a3b8",
                    animation: generalConfig.enabled ? "sbPontoVivo 2s ease-in-out infinite" : "none",
                  }}
                />
                IA {generalConfig.enabled ? "ligada" : "desligada"}
              </span>
            </div>
            <Tabs
              value={tab}
              onChange={(e, newVal) => setTab(newVal)}
              className={classes.tabs}
              variant="scrollable"
              scrollButtons="off"
            >
              <Tab icon={<TuneRoundedIcon />} label="Configurações globais" />
              <Tab icon={<MemoryOutlinedIcon />} label="IA" />
              <Tab icon={<AccountBalanceOutlinedIcon />} label="Bancos" />
              <Tab icon={<RecordVoiceOverOutlinedIcon />} label="Áudio" />
            </Tabs>
          </div>

          {}
          {}
          <TabPanel value={tab} index={0} className={classes.tabPanel}>
            {/* ================= CONEXOES E MODELO ================= */}
            <div className={classes.cfgSecao}>
              <div className={classes.cfgSecaoHead}>
                <div className={classes.cfgIcone}><VpnKeyOutlinedIcon /></div>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div className={classes.cfgTitulo}>Conexões e modelo</div>
                  <div className={classes.cfgSub}>Liga a assistente, escolhe o modelo e guarda as chaves de acesso.</div>
                </div>
                <span className={`${classes.cfgPill} ${generalConfig.enabled ? classes.cfgPillOn : classes.cfgPillOff}`}>
                  <span className={classes.cfgPonto} /> IA {generalConfig.enabled ? "ligada" : "desligada"}
                </span>
              </div>

              <div className={classes.cfgCorpo}>
                <div className={classes.cfgGrid}>
                  {/* Assistente */}
                  <div className={classes.cfgBloco}>
                    <div className={classes.cfgBlocoTitulo}><PowerSettingsNewIcon /> Assistente</div>
                    <div className={classes.cfgSwitchLinha}>
                      <span>{generalConfig.enabled ? "Atendendo os clientes" : "Desligada para todos"}</span>
                      <Switch
                        checked={!!generalConfig.enabled}
                        onChange={e => setGeneralConfig({ ...generalConfig, enabled: e.target.checked })}
                        color="primary"
                        size="small"
                      />
                    </div>
                    {(() => {
                      const provedor = PROVEDORES[ehOpenAI(generalConfig.model) ? 1 : 0];
                      const atual = acharVersao(generalConfig.model || "claude-sonnet-5") ||
                        { familia: provedor.familias[0], versao: { id: generalConfig.model, nome: generalConfig.model, esforco: false } };
                      const familia = atual.familia;
                      const versao = atual.versao;
                      const trocarProvedor = (p) => {
                        if (p.id === provedor.id) return;
                        const v = p.familias[0].versoes[0];
                        setGeneralConfig({ ...generalConfig, model: v.id, modelEffort: "" });
                      };
                      const trocarFamilia = (f) => {
                        if (f.id === familia.id) return;
                        const v = f.versoes[0];
                        setGeneralConfig({
                          ...generalConfig,
                          model: v.id,
                          modelEffort: v.esforco ? generalConfig.modelEffort || "" : ""
                        });
                      };
                      return (
                        <>
                          <div className={classes.provedores}>
                            {PROVEDORES.map((p) => {
                              const ativo = p.id === provedor.id;
                              return (
                                <button
                                  key={p.id}
                                  type="button"
                                  title={ativo ? "Esta IA está atendendo" : `Clique para usar o ${p.nome} no lugar`}
                                  className={`${classes.familiaBtn} ${ativo ? classes.familiaAtiva : classes.provedorInativo}`}
                                  onClick={() => trocarProvedor(p)}
                                >
                                  <div className={classes.familiaNome}>{p.nome}</div>
                                  <div className={classes.familiaDesc}>{p.desc}</div>
                                  <span
                                    className={`${classes.provedorStatus} ${ativo ? classes.provedorStatusAtivo : classes.provedorStatusInativo}`}
                                  >
                                    {ativo ? "Ativa" : "Desativada · clique para ativar"}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                          <Typography variant="caption" color="textSecondary">
                            Só o <b>{provedor.nome}</b> responde aos clientes. O{" "}
                            {PROVEDORES.find((p) => p.id !== provedor.id).nome} fica desativado até você trocar.
                          </Typography>
                          {provedor.id === "openai" && !generalConfig.openaiApiKey && (
                            <Typography variant="caption" style={{ color: "#dc2626", fontWeight: 600 }}>
                              Cadastre a chave da OpenAI em "Chaves de API" — sem ela o ChatGPT não responde.
                            </Typography>
                          )}
                          <div className={classes.familias}>
                            {provedor.familias.map((f) => (
                              <button
                                key={f.id}
                                type="button"
                                className={`${classes.familiaBtn} ${f.id === familia.id ? classes.familiaAtiva : ""}`}
                                onClick={() => trocarFamilia(f)}
                              >
                                <div className={classes.familiaNome}>{f.nome}</div>
                                <div className={classes.familiaDesc}>{f.desc}</div>
                              </button>
                            ))}
                          </div>

                          <div className={classes.cfgLinha2}>
                          <FormControl variant="outlined" size="small" fullWidth className={classes.modernSelect}>
                            <InputLabel id="versao-claude">Versão</InputLabel>
                            <Select
                              labelId="versao-claude"
                              label="Versão"
                              value={versao.id}
                              onChange={(e) => {
                                const v = familia.versoes.find((x) => x.id === e.target.value);
                                setGeneralConfig({
                                  ...generalConfig,
                                  model: e.target.value,
                                  modelEffort: v && v.esforco ? generalConfig.modelEffort || "" : ""
                                });
                              }}
                              renderValue={() => versao.nome}
                              MenuProps={{
                                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                transformOrigin: { vertical: "top", horizontal: "left" },
                                getContentAnchorEl: null,
                                PaperProps: { style: { borderRadius: 12, minWidth: 300 } },
                              }}
                            >
                              {familia.versoes.map((v) => (
                                <MenuItem key={v.id} value={v.id}>
                                  <div className={classes.opcaoLinha}>
                                    <span className={classes.opcaoNome}>{v.nome}</span>
                                    {v.nota && <span className={classes.opcaoNota}>{v.nota}</span>}
                                    <span className={classes.opcaoPreco}>{usd(v.entrada)} / {usd(v.saida)}</span>
                                  </div>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          {versao.esforco ? (
                            <FormControl variant="outlined" size="small" fullWidth className={classes.modernSelect}>
                              <InputLabel id="esforco-claude" shrink>Esforço</InputLabel>
                              <Select
                                labelId="esforco-claude"
                                label="Esforço"
                                notched
                                displayEmpty
                                value={generalConfig.modelEffort || ""}
                                onChange={(e) => setGeneralConfig({ ...generalConfig, modelEffort: e.target.value })}
                                renderValue={(v) =>
                                  v ? NOME_ESFORCO[v] : `Padrão do modelo (${NOME_ESFORCO[versao.padrao] || "Alto"})`
                                }
                                MenuProps={{
                                  anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                  transformOrigin: { vertical: "top", horizontal: "left" },
                                  getContentAnchorEl: null,
                                  PaperProps: { style: { borderRadius: 12 } },
                                }}
                              >
                                {ESFORCOS.map((e) => (
                                  <MenuItem key={e.id || "padrao"} value={e.id}>
                                    <div>
                                      <div className={classes.opcaoNome}>
                                        {e.id ? e.nome : `Padrão do modelo (${NOME_ESFORCO[versao.padrao] || "Alto"})`}
                                      </div>
                                      {e.desc && <div className={classes.familiaDesc}>{e.desc}</div>}
                                    </div>
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : (
                            <Typography variant="caption" color="textSecondary" style={{ alignSelf: "center" }}>
                              Esta versão não tem ajuste de esforço.
                            </Typography>
                          )}
                          </div>

                          {versao.entrada !== undefined && (
                            <div className={classes.precoCaixa}>
                              <div className={classes.precoTile}>
                                <div className={classes.precoRotulo}>Entrada</div>
                                <div className={classes.precoValor}>{usd(versao.entrada)}</div>
                                <div className={classes.precoSub}>por milhão de tokens</div>
                              </div>
                              <div className={classes.precoTile}>
                                <div className={classes.precoRotulo}>Saída</div>
                                <div className={classes.precoValor}>{usd(versao.saida)}</div>
                                <div className={classes.precoSub}>por milhão de tokens</div>
                              </div>
                              <div className={classes.precoTile}>
                                <div className={classes.precoRotulo}>Esforço</div>
                                <div className={classes.precoValor}>
                                  {versao.esforco
                                    ? NOME_ESFORCO[generalConfig.modelEffort] || NOME_ESFORCO[versao.padrao] || "Alto"
                                    : "—"}
                                </div>
                                <div className={classes.precoSub}>
                                  {versao.esforco ? (generalConfig.modelEffort ? "escolhido" : "padrão do modelo") : "não se aplica"}
                                </div>
                              </div>
                            </div>
                          )}
                          {versao.aviso && (
                            <Typography variant="caption" style={{ color: "#dc2626", fontWeight: 600 }}>
                              {versao.aviso}
                            </Typography>
                          )}
                        </>
                      );
                    })()}
                  </div>

                  <div className={classes.cfgColuna}>
                  {/* Chaves */}
                  <div className={classes.cfgBloco}>
                    <div className={classes.cfgBlocoTitulo}><VpnKeyOutlinedIcon /> Chaves de API</div>
                    <TextField
                      label="Anthropic (Claude)"
                      variant="outlined"
                      size="small"
                      fullWidth
                      type="text"
                      inputProps={campoSecreto(segredosVisiveis.anthropic)}
                      value={generalConfig.apiKey || ""}
                      onChange={e => setGeneralConfig({ ...generalConfig, apiKey: e.target.value })}
                      InputProps={olhoMagico("anthropic")}
                      helperText={
                        generalConfig.apiKey
                          ? "Chave cadastrada"
                          : ehOpenAI(generalConfig.model)
                            ? "Opcional enquanto a IA for o ChatGPT."
                            : "Sem chave o Claude não responde."
                      }
                    />
                    <TextField
                      label="OpenAI (ChatGPT e áudios)"
                      variant="outlined"
                      size="small"
                      fullWidth
                      type="text"
                      inputProps={campoSecreto(segredosVisiveis.openai)}
                      value={generalConfig.openaiApiKey || ""}
                      onChange={e => setGeneralConfig({ ...generalConfig, openaiApiKey: e.target.value })}
                      InputProps={olhoMagico("openai")}
                      helperText={
                        ehOpenAI(generalConfig.model)
                          ? generalConfig.openaiApiKey ? "Chave cadastrada (ChatGPT e áudios)" : "Sem chave o ChatGPT não responde."
                          : "Opcional: transcreve os áudios só enquanto a IA atende (com vendedor, não)."
                      }
                    />
                  </div>

                  {/* Coonsigle */}
                  <div className={classes.cfgBloco}>
                    <div className={classes.cfgBlocoTitulo}><StorageOutlinedIcon /> Base de clientes (Coonsigle)</div>
                    <TextField
                      label="Token de API"
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      value={coonsigleToken}
                      onChange={(e) => setCoonsigleToken(e.target.value)}
                      placeholder="Cole o token gerado no Coonsigle"
                      InputProps={olhoMagico("coonsigle")}
                      inputProps={campoSecreto(segredosVisiveis.coonsigle, {
                        spellCheck: false,
                        style: { fontFamily: "monospace", fontSize: "0.82rem" }
                      })}
                      helperText={
                        coonsigleToken
                          ? `Token cadastrado · gere em Coonsigle → Minha API`
                          : "Sem token a IA não busca o CPF pelo telefone · gere em Coonsigle → Minha API"
                      }
                    />

                  </div>
                  </div>
                </div>
              </div>

              <div className={classes.cfgRodape}>
                <span className={classes.cfgRodapeTexto}>
                  {carregado ? "Salva o liga/desliga, o modelo, as chaves e o token." : "Carregando as configurações…"}
                </span>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.cfgBotao}
                  startIcon={<SaveOutlinedIcon />}
                  disabled={!carregado || salvando === "conexoes"}
                  onClick={handleSalvarConexoes}
                >
                  {salvando === "conexoes" ? "Salvando…" : "Salvar conexões"}
                </Button>
              </div>
            </div>

            {/* ================= PROMPTS ================= */}
            <div className={classes.cfgSecao}>
              <div className={classes.cfgSecaoHead}>
                <div className={classes.cfgIcone}><ForumOutlinedIcon /></div>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div className={classes.cfgTitulo}>Prompt de conversa</div>
                  <div className={classes.cfgSub}>Um prompt para cada produto. Ative os produtos que a IA atende.</div>
                </div>
                <div className={classes.cfgSeg}>
                  <button
                    type="button"
                    className={`${classes.cfgSegBtn} ${promptAba === "clt" ? classes.cfgSegAtivo : ""}`}
                    onClick={() => setPromptAba("clt")}
                  >
                    <span className={classes.cfgSegPonto} style={{ backgroundColor: generalConfig.promptCltAtivo !== false ? "#22c55e" : "#cbd5e1" }} />
                    Consignado CLT
                  </button>
                  <button
                    type="button"
                    className={`${classes.cfgSegBtn} ${promptAba === "fgts" ? classes.cfgSegAtivo : ""}`}
                    onClick={() => setPromptAba("fgts")}
                  >
                    <span className={classes.cfgSegPonto} style={{ backgroundColor: generalConfig.promptFgtsAtivo !== false ? "#22c55e" : "#cbd5e1" }} />
                    FGTS
                  </button>
                </div>
              </div>

              <div className={classes.cfgCorpo}>
                {(() => {
                  const clt = generalConfig.promptCltAtivo !== false;
                  const fgts = generalConfig.promptFgtsAtivo !== false;
                  return (
                    <div className={classes.cfgResumo}>
                      <ForumOutlinedIcon style={{ fontSize: 18, color: "#1E9855", marginTop: 1 }} />
                      <span>
                        {!clt && !fgts ? (
                          <>
                            <b>IA desativada.</b> O fluxo continua normal e, quando chegar na IA, o cliente vai
                            direto para um atendente.
                          </>
                        ) : (
                        <>
                        Quando o fluxo define o produto, vale o que está no bloco <b>Enviar para IA</b>
                        {!clt || !fgts ? <> (produto desligado vai direto para um atendente)</> : null}.
                        Quando não define:{" "}
                        {clt && fgts
                          ? <>a IA <b>pergunta ao cliente</b> se é CLT ou FGTS e segue com o prompt certo.</>
                          : clt
                          ? <>a IA atende direto como <b>Consignado CLT</b>.</>
                          : fgts
                          ? <>a IA atende direto como <b>FGTS</b>.</>
                          : null}
                        </>
                        )}
                      </span>
                    </div>
                  );
                })()}

                <div className={classes.cfgInfoPrompt}>
                  <span>
                    {promptAba === "clt"
                      ? "Prompt usado só com clientes do Consignado CLT."
                      : "Prompt usado só com clientes do FGTS (saque-aniversário)."}
                  </span>
                  <span className={classes.cfgAtivoLinha}>
                    {(promptAba === "clt" ? generalConfig.promptCltAtivo : generalConfig.promptFgtsAtivo) !== false
                      ? (promptAba === "fgts" && !String(generalConfig.fgtsSystemPrompt || "").trim()
                          ? <span className={`${classes.cfgPill} ${classes.cfgPillWarn}`}><span className={classes.cfgPonto} /> Ativo, mas sem prompt</span>
                          : <span className={`${classes.cfgPill} ${classes.cfgPillOn}`}><span className={classes.cfgPonto} /> Ativo</span>)
                      : <span className={`${classes.cfgPill} ${classes.cfgPillOff}`}><span className={classes.cfgPonto} /> Desativado</span>}
                    <Switch
                      size="small"
                      color="primary"
                      checked={(promptAba === "clt" ? generalConfig.promptCltAtivo : generalConfig.promptFgtsAtivo) !== false}
                      onChange={(e) => setGeneralConfig({
                        ...generalConfig,
                        [promptAba === "clt" ? "promptCltAtivo" : "promptFgtsAtivo"]: e.target.checked
                      })}
                    />
                  </span>
                </div>

                <TextField
                  key={promptAba}
                  className={classes.cfgPrompt}
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={10}
                  maxRows={22}
                  placeholder={promptAba === "clt"
                    ? "Instruções de como a IA conversa no consignado CLT…"
                    : "Instruções de como a IA conversa no FGTS (saque-aniversário)…"}
                  value={(promptAba === "clt" ? generalConfig.systemPrompt : generalConfig.fgtsSystemPrompt) || ""}
                  onChange={e => setGeneralConfig({
                    ...generalConfig,
                    [promptAba === "clt" ? "systemPrompt" : "fgtsSystemPrompt"]: e.target.value
                  })}
                />
              </div>

              <div className={classes.cfgRodape}>
                <span className={classes.cfgRodapeTexto}>
                  {(((promptAba === "clt" ? generalConfig.systemPrompt : generalConfig.fgtsSystemPrompt) || "").length).toLocaleString("pt-BR")} caracteres
                </span>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.cfgBotao}
                  startIcon={<SaveOutlinedIcon />}
                  disabled={!carregado || salvando === "prompt"}
                  onClick={handleSalvarPrompt}
                >
                  {salvando === "prompt" ? "Salvando…" : "Salvar prompt"}
                </Button>
              </div>
            </div>
          </TabPanel>

          {}
          <TabPanel value={tab} index={1} className={classes.tabPanel}>
            {(() => {
              const assinatura = iaConfig.assistantName ? `*${iaConfig.assistantName}:*\n` : "";
              const selectMenu = {
                PaperProps: { className: classes.modernSelectMenu, style: { maxHeight: 260, overflowY: "auto" } },
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
                getContentAnchorEl: null,
              };
              const pontoOnline = (a) => (
                <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", backgroundColor: a.online ? "#1E9855" : "#9ca3af", flexShrink: 0 }} />
              );

              return (
                <>
                  {/* ===== Empresa e assistente ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="empresa"
                    icone={<BusinessOutlinedIcon />}
                    titulo="Empresa e assistente"
                    sub="Como a IA se apresenta e os dados que ela usa quando o cliente pergunta sobre a empresa."
                  >
                    <div className={classes.iaGrid4}>
                      <TextField label="Nome da assistente" variant="outlined" size="small" fullWidth
                        value={iaConfig.assistantName || ""}
                        onChange={e => setIaConfig({ ...iaConfig, assistantName: e.target.value })}
                        helperText="Aparece nas mensagens do WhatsApp" />
                      <TextField label="Nome da empresa" variant="outlined" size="small" fullWidth
                        value={iaConfig.companyName || ""}
                        onChange={e => setIaConfig({ ...iaConfig, companyName: e.target.value })} />
                      <TextField label="Website" variant="outlined" size="small" fullWidth className={classes.iaSpan2}
                        value={iaConfig.website || ""}
                        onChange={e => setIaConfig({ ...iaConfig, website: e.target.value })} />
                      <TextField label="CNPJ" variant="outlined" size="small" fullWidth
                        value={iaConfig.cnpj || ""}
                        onChange={e => setIaConfig({ ...iaConfig, cnpj: e.target.value })} />
                      <TextField label="Anos de atuação" variant="outlined" size="small" fullWidth
                        value={iaConfig.yearsInBusiness || ""}
                        onChange={e => setIaConfig({ ...iaConfig, yearsInBusiness: e.target.value })} />
                      <TextField label="Estado" variant="outlined" size="small" fullWidth
                        value={iaConfig.state || ""}
                        onChange={e => setIaConfig({ ...iaConfig, state: e.target.value })} />
                      <TextField label="Cidade" variant="outlined" size="small" fullWidth
                        value={iaConfig.city || ""}
                        onChange={e => setIaConfig({ ...iaConfig, city: e.target.value })} />
                    </div>
                  </SecaoIa>

                  {/* ===== Notificacoes ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="notificacoes"
                    icone={<NotificationsActiveOutlinedIcon />}
                    titulo="Notificações"
                    sub="Relatórios e avisos enviados para o WhatsApp do admin."
                  >
                    <TextField
                      label="Número do admin (WhatsApp)"
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", maxWidth: 380 }}
                      value={getMaskedAdminNumber(iaConfig.adminNotificationNumber)}
                      onChange={aoDigitarTelefone("adminNotificationNumber")}
                      placeholder="(11) 99999-9999"
                      helperText="A IA e o fluxo visual nunca respondem automaticamente para este número."
                    />
                    <div className={classes.iaGrid3} style={{ marginTop: 16 }}>
                      <div className={classes.iaOpcao}>
                        <div className={classes.iaOpcaoTopo}>
                          <div>
                            <div className={classes.iaOpcaoTitulo}>Relatório diário</div>
                            <div className={classes.iaOpcaoTexto}>Resumo do dia no WhatsApp do admin.</div>
                          </div>
                          <Switch color="primary" size="small" checked={!!iaConfig.dailyNotifications}
                            onChange={e => setIaConfig({ ...iaConfig, dailyNotifications: e.target.checked })} />
                        </div>
                        {iaConfig.dailyNotifications && (
                          <TextField
                            label="Horário"
                            placeholder="18:00"
                            variant="outlined"
                            size="small"
                            style={{ width: 110 }}
                            value={iaConfig.dailyNotificationTime || ""}
                            onChange={aoDigitarHorario}
                            inputProps={{ maxLength: 5, style: { textAlign: "center", fontWeight: 600 } }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      </div>
                      <div className={classes.iaOpcao}>
                        <div className={classes.iaOpcaoTopo}>
                          <div>
                            <div className={classes.iaOpcaoTitulo}>Alertas no sistema</div>
                            <div className={classes.iaOpcaoTexto}>Avisos visuais e sonoros (mensagens, avisos e problemas).</div>
                          </div>
                          <Switch color="primary" size="small" checked={!!iaConfig.generalNotifications}
                            onChange={e => setIaConfig({ ...iaConfig, generalNotifications: e.target.checked })} />
                        </div>
                      </div>
                      <div className={classes.iaOpcao}>
                        <div className={classes.iaOpcaoTopo}>
                          <div>
                            <div className={classes.iaOpcaoTitulo}>Aviso de proposta</div>
                            <div className={classes.iaOpcaoTexto}>Avisa o admin sempre que a IA finalizar uma proposta.</div>
                          </div>
                          <Switch color="primary" size="small" checked={!!iaConfig.proposalNotifications}
                            onChange={e => setIaConfig({ ...iaConfig, proposalNotifications: e.target.checked })} />
                        </div>
                      </div>
                    </div>
                  </SecaoIa>

                  {/* ===== Atendente automatico ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="transferencia"
                    icone={<SwapHorizOutlinedIcon />}
                    titulo="Transferência automática"
                    sub="Para quem a IA passa o cliente quando não consegue concluir, e quanto tempo ela espera."
                  >
                    <div className={classes.iaGrid2}>
                      <FormControl variant="outlined" size="small" fullWidth className={classes.modernSelect}>
                        <InputLabel id="auto-product-label">Produto</InputLabel>
                        <Select
                          labelId="auto-product-label"
                          label="Produto"
                          value={iaConfig.autoTransferProduct || ""}
                          onChange={e => setIaConfig({ ...iaConfig, autoTransferProduct: e.target.value })}
                          MenuProps={selectMenu}
                        >
                          <MenuItem value="" className={classes.modernMenuItem}>Nenhum</MenuItem>
                          <MenuItem value="both" className={classes.modernMenuItem}>Ambos (CLT e FGTS)</MenuItem>
                          <MenuItem value="clt" className={classes.modernMenuItem}>Consignado CLT</MenuItem>
                          <MenuItem value="fgts" className={classes.modernMenuItem}>FGTS</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl variant="outlined" size="small" fullWidth className={classes.modernSelect}>
                        <InputLabel id="auto-user-label">Atendente de destino</InputLabel>
                        <Select
                          labelId="auto-user-label"
                          label="Atendente de destino"
                          value={iaConfig.autoTransferUserId || ""}
                          onChange={e => setIaConfig({ ...iaConfig, autoTransferUserId: e.target.value })}
                          MenuProps={selectMenu}
                        >
                          <MenuItem value="" className={classes.modernMenuItem}>Nenhum (deixa na espera)</MenuItem>
                          <MenuItem value="random" className={classes.modernMenuItem}>Aleatório (sorteia entre os atendentes)</MenuItem>
                          {atendentes.map(a => (
                            <MenuItem key={a.id} value={String(a.id)} className={classes.modernMenuItem}>
                              <Box display="flex" alignItems="center" style={{ gap: 8 }}>{pontoOnline(a)}{a.name}</Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <FormControl variant="outlined" size="small" fullWidth className={classes.modernSelect} style={{ marginTop: 16 }}>
                      <InputLabel id="auto-users-label">Vendedores que recebem automaticamente</InputLabel>
                      <Select
                        labelId="auto-users-label"
                        label="Vendedores que recebem automaticamente"
                        multiple
                        value={iaConfig.autoTransferUserIds || []}
                        onChange={e => {
                          const val = e.target.value;
                          if (Array.isArray(val) && val.includes("__todos__")) {
                            const todosIds = atendentes.map(a => String(a.id));
                            const jaTodos =
                              (iaConfig.autoTransferUserIds || []).length === todosIds.length && todosIds.length > 0;
                            setIaConfig({ ...iaConfig, autoTransferUserIds: jaTodos ? [] : todosIds });
                            return;
                          }
                          setIaConfig({ ...iaConfig, autoTransferUserIds: val });
                        }}
                        renderValue={selecionados => (
                          <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                            {(selecionados || []).map(id => {
                              const a = atendentes.find(u => String(u.id) === String(id));
                              return <Chip key={id} size="small" label={a ? a.name : id} />;
                            })}
                          </Box>
                        )}
                        MenuProps={selectMenu}
                      >
                        <MenuItem value="__todos__" className={classes.modernMenuItem}>
                          <em>
                            {(iaConfig.autoTransferUserIds || []).length === atendentes.length && atendentes.length > 0
                              ? "Desmarcar todos"
                              : "Selecionar todos"}
                          </em>
                        </MenuItem>
                        {atendentes.map(a => (
                          <MenuItem key={a.id} value={String(a.id)} className={classes.modernMenuItem}>
                            <Box display="flex" alignItems="center" style={{ gap: 8 }}>{pontoOnline(a)}{a.name}</Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 6 }}>
                      Com vendedores marcados, a IA sorteia entre eles. Sem ninguém marcado, vale o "Atendente de destino".
                    </Typography>

                    <div className={classes.iaRotulo}>Tempos de espera</div>
                    <div className={classes.iaGrid3}>
                      {[
                        { chave: "flowTimeoutMinutes", rotulo: "No fluxo", padrao: 10,
                          texto: "Quanto o fluxo visual espera o cliente responder antes de passar para uma pessoa.",
                          desligado: "0 desliga" },
                        { chave: "iaTimeoutMinutes", rotulo: "Na assistente", padrao: 15,
                          texto: "O mesmo, com a IA atendendo (só conta quando a última mensagem foi nossa). Também é a espera pelo link de formalização depois da digitação.",
                          desligado: "0 desliga" },
                        ...(!iaConfig.autoTransferUserId
                          ? [{ chave: "overflowTimeoutMinutes", rotulo: "Para sortear", padrao: 10,
                               texto: "Sem atendente fixo, o admin é avisado. Passado esse tempo, a IA sorteia alguém online.",
                               desligado: "0 desliga o sorteio" }]
                          : [])
                      ].map(campo => (
                        <div key={campo.chave} className={classes.iaOpcao}>
                          <div className={classes.iaOpcaoTitulo}>{campo.rotulo}</div>
                          <div className={classes.iaOpcaoTexto} style={{ flexGrow: 1 }}>{campo.texto}</div>
                          <TextField
                            variant="outlined"
                            size="small"
                            value={iaConfig[campo.chave] ?? campo.padrao}
                            onChange={e => setIaConfig({ ...iaConfig, [campo.chave]: e.target.value.replace(/\D/g, "").slice(0, 4) })}
                            inputProps={{ inputMode: "numeric" }}
                            InputProps={{ endAdornment: <span style={{ fontSize: 12.5, color: "#9ca3af" }}>min</span> }}
                            helperText={campo.desligado}
                            style={{ maxWidth: 150 }}
                          />
                        </div>
                      ))}
                      <div className={classes.iaOpcao}>
                        <div className={classes.iaOpcaoTitulo}>Retomar após falha</div>
                        <div className={classes.iaOpcaoTexto} style={{ flexGrow: 1 }}>
                          Quando a assistente pausa por falha técnica (ex.: créditos da Anthropic esgotados), quanto tempo ela espera para tentar de novo sozinha.
                        </div>
                        <TextField
                          variant="outlined"
                          size="small"
                          value={iaConfig.retomadaPausaSegundos ?? "1:30"}
                          onChange={e => setIaConfig({ ...iaConfig, retomadaPausaSegundos: e.target.value.replace(/[^\d:]/g, "").slice(0, 5) })}
                          onBlur={() => setIaConfig({ ...iaConfig, retomadaPausaSegundos: segundosParaTexto(textoParaSegundos(iaConfig.retomadaPausaSegundos)) })}
                          inputProps={{ inputMode: "numeric" }}
                          InputProps={{ endAdornment: <span style={{ fontSize: 12.5, color: "#9ca3af" }}>min:seg</span> }}
                          helperText="ex.: 1:30 · mínimo 0:30"
                          style={{ maxWidth: 150 }}
                        />
                      </div>
                    </div>
                  </SecaoIa>

                  {/* ===== Mensagem de abertura ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="abertura"
                    icone={<ChatBubbleOutlineIcon />}
                    titulo="Mensagem de abertura"
                    sub="Primeira mensagem que a assistente envia ao assumir o atendimento."
                  >
                    <div className={classes.iaGrid2}>
                      <div>
                        <TextField
                          label="Texto da mensagem"
                          variant="outlined"
                          size="small"
                          fullWidth
                          multiline
                          minRows={4}
                          value={iaConfig.leadQualificationMessage || ""}
                          onChange={e => setIaConfig({ ...iaConfig, leadQualificationMessage: e.target.value })}
                        />
                        <div className={classes.fotoArea}>
                          <input
                            id="input-foto-assistente"
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                            style={{ display: "none" }}
                            onChange={escolherFoto}
                          />
                          {urlFotoAssistente ? (
                            <Tooltip title="Editar foto (recortar, girar, zoom)">
                              <div className={classes.fotoMini} onClick={editarFotoAtual} role="button" tabIndex={0}
                                onKeyPress={e => { if (e.key === "Enter") editarFotoAtual(); }}>
                                <img src={urlFotoAssistente} alt="Foto da assistente" />
                                <span className={classes.fotoLapis}>
                                  {abrindoFoto ? <CircularProgress size={18} style={{ color: "#fff" }} /> : <EditOutlinedIcon fontSize="small" />}
                                </span>
                              </div>
                            </Tooltip>
                          ) : (
                            <label htmlFor="input-foto-assistente" className={classes.fotoVazia}>
                              <ImageOutlinedIcon />
                            </label>
                          )}
                          <label htmlFor="input-foto-assistente">
                            <Button component="span" variant="outlined" size="small" disabled={enviandoFoto}
                              startIcon={enviandoFoto ? <CircularProgress size={14} /> : <ImageOutlinedIcon fontSize="small" />}>
                              {urlFotoAssistente ? "Trocar foto" : "Adicionar foto"}
                            </Button>
                          </label>
                          {urlFotoAssistente && (
                            <Button size="small" disabled={enviandoFoto} onClick={removerFoto}
                              startIcon={<DeleteOutlineIcon fontSize="small" />}>
                              Remover
                            </Button>
                          )}
                          <span className={classes.fotoDica}>
                            Opcional. A foto sai junto com a mensagem de abertura, com o texto como legenda.
                            Dá para recortar, girar e ajustar o zoom antes de salvar. A foto é salva na hora.
                          </span>
                        </div>
                        <div className={classes.iaOpcao} style={{ marginTop: 16 }}>
                          <div className={classes.iaOpcaoTopo}>
                            <div>
                              <div className={classes.iaOpcaoTitulo}>Reenviar se o cliente não responder</div>
                              <div className={classes.iaOpcaoTexto}>Para assim que o cliente responder ou um atendente assumir.</div>
                            </div>
                            <Switch color="primary" size="small" checked={!!iaConfig.leadQualificationFollowUp}
                              onChange={e => setIaConfig({ ...iaConfig, leadQualificationFollowUp: e.target.checked })} />
                          </div>
                          {iaConfig.leadQualificationFollowUp && (
                            <Box display="flex" style={{ gap: 12 }} flexWrap="wrap">
                              <TextField
                                label="Reenviar após"
                                variant="outlined"
                                size="small"
                                style={{ width: 150 }}
                                value={iaConfig.leadQualificationFollowUpMinutes ?? 30}
                                onChange={e => setIaConfig({ ...iaConfig, leadQualificationFollowUpMinutes: e.target.value.replace(/\D/g, "").slice(0, 4) })}
                                inputProps={{ inputMode: "numeric" }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ endAdornment: <span style={{ fontSize: 12.5, color: "#9ca3af" }}>min</span> }}
                              />
                              <TextField
                                label="Máximo de lembretes"
                                variant="outlined"
                                size="small"
                                style={{ width: 170 }}
                                value={iaConfig.leadQualificationFollowUpMax ?? 1}
                                onChange={e => setIaConfig({ ...iaConfig, leadQualificationFollowUpMax: e.target.value.replace(/\D/g, "").slice(0, 2) })}
                                inputProps={{ inputMode: "numeric" }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Box>
                          )}
                        </div>
                      </div>
                      <ZapPrevia classes={classes} emoji="💬" nome={iaConfig.assistantName || "Assistente"} sub="Prévia — mensagem de abertura">
                        <span className={classes.zapBalao} style={urlFotoAssistente ? { padding: 4 } : undefined}>
                          {urlFotoAssistente && <img className={classes.zapFoto} src={urlFotoAssistente} alt="Foto da assistente" />}
                          <span style={urlFotoAssistente ? { display: "block", padding: "2px 8px 6px" } : undefined}>
                            {assinatura}{iaConfig.leadQualificationMessage || ""}
                          </span>
                        </span>
                      </ZapPrevia>
                    </div>
                  </SecaoIa>

                  {/* ===== Audio do cliente ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="audio"
                    icone={<MicNoneOutlinedIcon />}
                    titulo="Áudio do cliente"
                    sub="Cliente mandou áudio: vai direto para uma pessoa. Com a aba Áudio ligada (Quando o cliente mandar áudio), quem responde é a IA, em voz."
                    acao={
                      <span className={`${classes.cfgPill} ${iaConfig.audioToHumanEnabled !== false ? classes.cfgPillOn : classes.cfgPillOff}`}>
                        <span className={classes.cfgPonto} /> {iaConfig.audioToHumanEnabled !== false ? "Ligado" : "Desligado"}
                        <Switch color="primary" size="small" checked={iaConfig.audioToHumanEnabled !== false}
                          onChange={e => setIaConfig({ ...iaConfig, audioToHumanEnabled: e.target.checked })} />
                      </span>
                    }
                  >
                    {iaConfig.audioToHumanEnabled !== false ? (
                      <div className={classes.iaGrid2}>
                        <TextField
                          label="Mensagem para o cliente"
                          variant="outlined"
                          size="small"
                          fullWidth
                          multiline
                          minRows={4}
                          value={iaConfig.audioToHumanMessage || ""}
                          onChange={e => setIaConfig({ ...iaConfig, audioToHumanMessage: e.target.value })}
                          placeholder="Recebi seu áudio! 😊 Vou chamar um atendente pra falar com você, só um momentinho."
                          helperText="Em branco, o sistema usa o texto de exemplo."
                        />
                        <ZapPrevia classes={classes} emoji="🎤" nome={iaConfig.assistantName || "Assistente"} sub="Prévia — cliente mandou áudio">
                          <span className={classes.zapBalao} style={{ color: "#667781", marginBottom: 8 }}>▶ ▁▃▅▂▇▃▁▅▂ 0:12</span>
                          <br />
                          <span className={`${classes.zapBalao} ${classes.zapBalaoMeu}`}>
                            {(iaConfig.audioToHumanMessage || "").trim() ||
                              "Recebi seu áudio! 😊 Vou chamar um atendente pra falar com você, só um momentinho."}
                          </span>
                          <div style={{ clear: "both" }} />
                        </ZapPrevia>
                      </div>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Desligado: o áudio segue o caminho normal (fluxo e IA com a transcrição).
                      </Typography>
                    )}
                  </SecaoIa>

                  {/* ===== Base de conhecimento (CLT e FGTS) ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="conhecimento"
                    icone={<MenuBookOutlinedIcon />}
                    titulo="Base de conhecimento"
                    sub="O que a IA usa para tirar dúvidas dos clientes (prazo do pagamento, consulta de score etc.)."
                    acao={
                      <div className={classes.cfgSeg}>
                        <button
                          type="button"
                          className={`${classes.cfgSegBtn} ${faqAba === "clt" ? classes.cfgSegAtivo : ""}`}
                          onClick={() => setFaqAba("clt")}
                        >
                          <span className={classes.cfgSegPonto} style={{ backgroundColor: String(iaConfig.faqContent || "").trim() ? "#22c55e" : "#cbd5e1" }} />
                          Consignado CLT
                        </button>
                        <button
                          type="button"
                          className={`${classes.cfgSegBtn} ${faqAba === "fgts" ? classes.cfgSegAtivo : ""}`}
                          onClick={() => setFaqAba("fgts")}
                        >
                          <span className={classes.cfgSegPonto} style={{ backgroundColor: String(iaConfig.faqFgtsContent || "").trim() ? "#22c55e" : "#cbd5e1" }} />
                          FGTS
                        </button>
                      </div>
                    }
                  >
                    <div className={classes.cfgInfoPrompt}>
                      <span>
                        {faqAba === "clt"
                          ? "Usada só com clientes do Consignado CLT."
                          : "Usada só com clientes do FGTS. Em branco, a IA responde com o que já sabe sobre FGTS."}
                      </span>
                    </div>
                    <TextField
                      key={faqAba}
                      variant="outlined"
                      size="small"
                      fullWidth
                      multiline
                      minRows={8}
                      maxRows={18}
                      value={(faqAba === "clt" ? iaConfig.faqContent : iaConfig.faqFgtsContent) || ""}
                      onChange={e => setIaConfig({ ...iaConfig, [faqAba === "clt" ? "faqContent" : "faqFgtsContent"]: e.target.value })}
                      placeholder={faqAba === "clt"
                        ? "Quanto tempo demora para o dinheiro cair?\nDepois da assinatura, o valor costuma cair em até 1 dia útil.\n\nPrecisa consultar o SPC/Serasa?\nNão, o consignado CLT não consulta score."
                        : "Quanto tempo demora para o dinheiro cair?\nDepois da assinatura, o valor costuma cair em até 1 dia útil.\n\nPreciso ter o saque-aniversário ativo?\nSim, a antecipação usa o saque-aniversário do FGTS."}
                      helperText="Pergunta em uma linha e a resposta embaixo. Separe cada bloco com uma linha em branco."
                    />
                  </SecaoIa>

                  {/* ===== Pagamento confirmado ===== */}
                  <SecaoIa classes={classes} salvando={salvando} onSalvar={salvarBlocoIa}
                    id="pagamento"
                    icone={<PaymentOutlinedIcon />}
                    titulo="Mensagem após pagamento confirmado"
                    sub="Enviada sozinha quando o banco confirma o pagamento (CLT e FGTS). Em branco, nada é enviado."
                  >
                    <div className={classes.iaGrid2}>
                      <TextField
                        label="Texto da mensagem"
                        variant="outlined"
                        size="small"
                        fullWidth
                        multiline
                        minRows={4}
                        value={iaConfig.paymentSuccessMessage || ""}
                        onChange={e => setIaConfig({ ...iaConfig, paymentSuccessMessage: e.target.value })}
                        helperText={`${(iaConfig.paymentSuccessMessage || "").length}/4000 caracteres`}
                      />
                      <ZapPrevia classes={classes} emoji="✅" nome={iaConfig.assistantName || "Assistente"} sub="Prévia — pagamento confirmado">
                        {iaConfig.paymentSuccessMessage
                          ? <span className={classes.zapBalao}>{assinatura}{iaConfig.paymentSuccessMessage}</span>
                          : <Typography variant="caption" color="textSecondary">Sem mensagem: nada é enviado.</Typography>}
                      </ZapPrevia>
                    </div>
                  </SecaoIa>
                </>
              );
            })()}
          </TabPanel>

          {}
          <TabPanel value={tab} index={2} className={classes.tabPanel}>
            <BankEnginePanel />
          </TabPanel>

          <TabPanel value={tab} index={3} className={classes.tabPanel}>
            <AbaAudio classes={classes} assistantName={iaConfig.assistantName} />
          </TabPanel>

        </Paper>
      </Container>

    </div>
  );
};

export default AIConfig;
